
/**
 * Given relevant information about the search request and possible additional info about
 * profileId and templateType, create a new template that will handle the search pdf request.
 *
 * @param {Number} filterQdt - qdt of the inline element to load
 * @param {Object} filters - associated filters to load for the inline element.
 * @param {Number} filterElementCount - size of the searchify set
 * @param {String} downloadName - name of the search pdf, will be associated to the header title.
 * @param {Number} profileQdt - Type of template QDT to load, defaults to blank download.
 * @param {object} defaultOrgDesign - orgdesign to load for search pdf.
 */
export const createSearchRequestStore = ({
    profileQdt,
    defaultOrgDesign,
    filterQdt,
    filters,
    filterElementCount,
    downloadName,
}) => ({
    profileQdt,
    [profileQdt]: {},
    currentOrgDesign: defaultOrgDesign,
    searchRequest: {
        filterQdt,
        filters,
        filterElementCount,
        downloadName
    },
})
